<template>
    <div class="certificate">
        <div class="content">
            <div class="top-line">
                <img src="../../assets/images/serialno/logo.png" class="icon">
                <div class="search">
                    <img src="../../assets/images/search.png" class="search" @click="searchInfo">
                    <input v-model="searchHash" class="search" placeholder="手机哈希" v-on:keyup.enter="searchInfo">                    
                </div>
            </div>
            <div v-if="isValid">
                <div class="form-centent">
                    <p class="title-line">区块信息</p>
                    <div class="block-form">
                        <ul>
                            <li>
                                <span>区块高度</span>
                                <span>{{form.height}}</span>
                            </li>
                            <li>
                                <span>手机哈希</span>
                                <p class="copy"
                                    v-clipboard:copy="form.hash"
                                    v-clipboard:success="success"
                                    v-clipboard:error="error">复制</p>
                                <span>{{[form.hash,size]|filterHash}}</span>
                            </li>
                            <li>
                                <span>上链时间</span>
                                <span>{{form.blockTime|fulltime}}</span>
                            </li>
                        </ul>
                    </div>
                    <p class="title-line">手机信息</p>
                    <div>
                        <ul>
                            <li>
                                <span>品牌</span>
                                <span>{{userInfo.brand}}</span>
                            </li>
                            <li>
                                <span>型号</span>
                                <span>{{userInfo.model}}</span>
                            </li>
                            <li>
                                <span>尺寸</span>
                                <span>{{userInfo.height}} * {{userInfo.width}}</span>
                            </li>
                            <li>
                                <span>运行内存</span>
                                <span>{{userInfo.ram}}</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div v-else class="tips">
                输入手机哈希检索手机信息
            </div>
        </div>
    </div>
</template>

<script>
import { Toast,Indicator } from "mint-ui";
import { checkMobileHash } from "../../assets/js/filter.js"
export default {
    data(){
        return{
            searchHash:'',
            addr:'18WdwumL69oMLEyLji1FNiQ8SUNqyqajRV', //发证地址
            form:Object,
            userInfo:'',
            isValid:false,
        }
    },
    computed:{
        size(){
            return document.body.clientWidth
        }
    },
    mounted(){
        const hash = this.$route.query.hash ? this.$route.query.hash:this.searchHash
        this.searchHash = hash.trim()
        if ( hash ) {
            this.searchInfo()
        }
    },
    methods:{
        searchInfo(){
            if (this.searchHash.trim() === "") return Toast("请输入手机哈希");
            else{
                Indicator.open("查询中...")
                this.$chain33Rpc.queryTransaction(this.searchHash).then((data)=>{
                    if(data.error===null){
                        this.userInfo = checkMobileHash(data.result,this.addr)
                        if(typeof(this.userInfo)==='object'){
                            this.isValid = true
                            this.form = data.result
                            this.form.hash = this.searchHash
                            this.$router.push(`/serialno.html?hash=${this.form.hash}`)
                        }else{
                            this.isValid = false
                            Toast(this.userInfo)
                        }
                        this.searchHash = ''
                    }else{
                        Toast('输入哈希错误')
                    }
                    Indicator.close()
                }).catch(()=>{
                    Indicator.close()
                })
            }
        },
        success(){
            Toast("复制成功");
        },
        error(){
            Toast("复制失败");
        }
    }
}
</script>

<style lang="scss">
.certificate{
    max-width: 1000px;
    min-height: 100vh;
    margin: 0 auto;
    background: #fff;
    ul,li{ padding:0;margin:0;list-style:none}
    .content{
        padding: 4vw;
        .title-line{
            height:50px;
            font-size:16px;
            font-weight:600;
            color:rgba(51,51,51,1);
            line-height:50px;
            padding-left: 5px;
            margin: 10px 0 0 0;
        }
        .top-line{
            .icon{
                width: 200px;
            }
            .search{
                -webkit-appearance: none;
                height: 39px;
                line-height: 39px;
                position: relative;
                display: flex;
                align-items: center;
            }
            .search:focus {
                outline:none;
            }
            div.search{
                margin-top: 3vw
            }
            img.search{
                z-index: 10;
                position: absolute;
                height: 20px;
                left: 15px;;
            }
            input.search{
                width: 100%;
                padding: 0 30px 0 45px;
                border:none;
                background:rgba(248,248,250,1);
                border-radius:20px;
                font-size: 14px;
            }
        }
        .form-centent{
            margin-top: 10px;
            ul li{
                height: 50px;
                line-height: 50px;
                border:1px solid rgba(217,217,217,1);
                border-bottom: none;
                color: #666666;
                padding: 0 10px;
                .college-icon{
                    height: 50px;
                    float: right;
                    display: flex;
                    align-items: center;
                    img{
                        width: 70%;
                    }
                }
                .copy{
                    margin: 0 0 0 10px;
                    float: right;
                    color: #5361FF;
                    cursor: pointer;
                }
                span:nth-of-type(2){
                    float: right;
                }
            }
            ul li:last-child{
                border-bottom: 1px solid rgba(217,217,217,1);
            }
        }      
    }
}
.tips{
    margin-top: 100px;
    text-align: center;
    color: #666666;
}
</style>


